import PhotoOverlay from '../src/PhotoOverlay';
export default PhotoOverlay;
